<template>
  <div class="app-container">

    <component :is="currentComponent" :parkingInfo="selectedParking" :selectedOfferCard="selectedOfferCard"
      :discount="discount" :discountHours="selectedDiscountHours" :unpaidFee="remainingFee" :carNumber="carNumber"
      :parkingFee="parkingFee"
      :showOtherParking="showOtherParking"
      :supportsCardDiscount="supportsCardDiscount"
      @nextStep="nextStep" @updateState="updateState" @cancel-payment="onCancel"
      @get-events="onGetEvents"
      @query-parking-fee="onQueryParkingFee" @go-card-discount="goCardDiscount" @go-online-payment="goOnlinePayment"
      @enter-card-number="enterCardNumber" @go-back-to-select-card="goBackToSelectCard"
      @card-number-entered="onQueryCardDiscount" @discount-hours-selected="doubleConfirm"
      @discount-hours-double-confirmed="attemptCardDiscount" @show-residual-fee="onShowResidualFee" />

    <component :is="getCurrentModal" :parkingInfo="selectedParking" :selectedOfferCard="selectedOfferCard"
      :discountHours="selectedDiscountHours" :unpaidFee="remainingFee" :carNumber="carNumber" :parkingFee="parkingFee"
      @updateState="updateState" @cancel-payment="onCancel" 
      @get-events="onGetEvents"
      @query-parking-fee="onQueryParkingFee"
      @enter-card-number="enterCardNumber" @go-back-to-select-card="goBackToSelectCard"
      @card-number-entered="onQueryCardDiscount" @discount-hours-selected="doubleConfirm"
      @discount-hours-double-confirmed="attemptCardDiscount" @cancel-discount="goBackToSelectCard"
      @show-residual-fee="onShowResidualFee" @cancel-card-select="onCancelSelectCard"
      @registered-card-selected="onQueryCardDiscount" />

  </div>
  <div v-if='debug' class="payboard">
    <p> current Step {{ currentStep }}</p>
    <p>Car Number {{ carNumber }}</p>
    <p>Parking Time {{ parkingStartTime }}</p>
    <p>Parking Fee {{ parkingFee }}</p>
    <p>Card Type {{ CardSelect }}</p>
    <p>Session ID {{ sessionId }}</p>
  </div>
  <div v-if='debug' class="payboard">
    <p>Selected Offer Card {{ selectedOfferCard }}</p>
    <p>Card Number {{ cardNumber }}</p>
    <p>Expire Date {{ expireDate }}</p>
    <p>Unpaid Fee {{ unpaidFee }}</p>
    <p>Discount Hours {{ selectedDiscountHours }}</p>
    <p>Remaining Fee {{ remainingFee }}</p>
    <p>Discount {{ discount }}</p>
    <!-- <p>Seletected Parking {{ selectedParking }}</p> -->
    <p> parking Info {{ selectedParking.parking_id }} | {{ selectedParking.title }} {{ selectedParking.address }} AgreementID# {{
      selectedParking.agreement_id }}</p>
      <p>Event ID {{ event_id }}</p>
      <p>Field No {{ field_no }}</p>
      <p>Plate Number {{ plate_number }}</p>
  </div>
  <div v-if="isLoading">
    <LoadingSpinner :loadingText="loadingText" />
  </div>
</template>

<script>
import { queryParkingFee, doCardDiscount, closeSession } from '@/util/parkingpayment';
import { getEvents } from '@/util/parkingpayment';
// import { queryParkingFee, doCardDiscount } from '@/util/parkingpayment';
// import { queryParkingFee } from '@/util/parkingpayment';

import { globalParams, getAgreementId } from '@/global';


import CarNumber from './payment/CarNumber.vue';
import CarFee from './payment/CarFeeDirect.vue';
import CardSelect from './payment/CardSelect.vue';
import CardSelectLogined from './payment/CardSelectLogined.vue';
import CardNumberEntry from './payment/CardNumberEntry.vue';
import CalculateDiscount from './payment/CalculateDiscount.vue';
import SelectDiscountHours from './payment/SelectDiscountHours.vue';
import MyConfirm from './payment/MyConfirm.vue';
import DoubleConfirm from './payment/DoubleConfirm.vue';
import DisplayResidualFee from './payment/DisplayResidualFee.vue';
import ShowSuccess from './payment/ShowSuccess.vue';
import RemainFee from './payment/RemainFeeDirect.vue';

import LoadingSpinner from '@/components/LoadingSpinner.vue';

// import { onMounted } from 'vue';
// import ParkingPaymentDAO from '@/services/ParkingPaymentDAO';




export default {



  data() {
    return {
      debug: process.env.VUE_APP_ENABLE_CARD_DISCOUNT_DEBUG === 'true',
      selectedParking: {
        parking_id: "0000",
        title: '',
        address: 'NoWhere',
        agreement_id: 'ESTP9999',
        longitude: "121.525639",
        latitude: "25.057053"
      },
      currentStep: 'CarNumber', // Tracks which step we are in
      currentModal: '',
      steps: [
        'CarNumber',
        'CarFee',
        'CardSelect',
        'CardSelectLogined',
        'CardNumberEntry',
        'CalculateDiscount',
        'SelectDiscountHours',
        'MyConfirm',
        'DoubleConfirm',
        'DisplayResidualFee',

      ],
      carNumber: '',
      parkingStartTime: '',
      CardSelect: '',
      parkingFee: 0,
      sessionId: '',
      // 金額變動確認後只允許重送一次，避免一直跳確認框
      feeChangeRetried: false,
      selectedOfferCard: '',
      cardNumber: '',
      expireDate: '',
      selectedDiscountHours: 0,
      remainingFee: 0,
      discount: 0,
      isLoading: false,
      showOtherParking: false,
      // 尋車用的使用者座標；null 表示取不到，後端會回退全台預設範圍
      userCoords: null,
      // 座標取得狀態，會一併送給後端記入日誌，方便分辨「沒帶座標」的真正原因
      //   url         來自網址參數
      //   granted     使用者允許定位
      //   denied      使用者拒絕（或曾封鎖此網站）
      //   timeout     定位逾時
      //   unavailable 取不到位置
      //   insecure    非安全來源（http + 非 localhost），瀏覽器不提供定位
      //   unsupported 瀏覽器不支援
      //   waited_out  查詢時定位仍未回覆（等待逾時）
      //   not_asked   尚未授權過，不主動詢問（2026-09-17 起後端先比對在場車號，不再需要定位）
      coordStatus: 'pending',
      coordPromise: null,
      coordElapsed: null,
      loadingText: '車號查詢中…請稍後'

    };
  },
  computed: {
    // ...mapGetters(['selectedParking']),

    currentComponent() {
      // Return the component name based on the current step
      return this.currentStep;
    },

    getCurrentModal() {
      return this.currentModal;
    },

    supportsCardDiscount() {
      const agreementId = this.selectedParking && this.selectedParking.agreement_id;
      return agreementId !== null && agreementId !== undefined && String(agreementId).trim() !== '';
    }

  },
  methods: {

    // 取得尋車用座標。優先序：
    //   1. 網址參數 ?lng=&lat=（例如停車場 QR code 帶入）
    //   2. 瀏覽器定位（需使用者授權且頁面為 https）
    // 兩者皆失敗就維持 null，後端會回退為全台預設搜尋範圍，不影響原有流程。
    // 座標優先序：網址參數（QR code）> 上次成功的座標 > 瀏覽器定位。
    // 2026-09-17 起後端會先比對在場車號找出場站，不再需要客人定位，
    // 頁面頂端的「開啟定位」說明已移除；只有客人早已授權過才取用座標，不主動跳授權對話框。
    async initUserCoords() {
      this.coordPromise = Promise.resolve();

      const q = (this.$route && this.$route.query) || {};
      const qLng = q.lng || q.longitude;
      const qLat = q.lat || q.latitude;
      if (qLng && qLat && !isNaN(Number(qLng)) && !isNaN(Number(qLat))) {
        this.userCoords = { longitude: String(qLng), latitude: String(qLat) };
        this.coordStatus = 'url';
        console.log('尋車座標來自網址參數:', this.userCoords);
        return;
      }

      // 先套用上次成功取得的座標，讓這次查詢立刻有範圍可用
      const cached = this.loadCachedCoords();
      if (cached) {
        this.userCoords = cached;
        this.coordStatus = 'cached';
        console.log('先採用上次記住的座標:', cached);
      }

      // https 或 localhost 以外的來源，瀏覽器不提供定位（也不會跳授權對話框）
      if (typeof window !== 'undefined' && window.isSecureContext === false) {
        if (!cached) this.coordStatus = 'insecure';
        console.log('非安全來源，無法定位');
        return;
      }
      if (!navigator.geolocation) {
        if (!cached) this.coordStatus = 'unsupported';
        return;
      }

      let state = 'prompt';
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const st = await navigator.permissions.query({ name: 'geolocation' });
          state = st.state;
        }
      } catch (e) {
        state = 'prompt'; // 部分 Safari 版本不支援查詢，一律視為可詢問
      }

      if (state === 'granted') {
        this.startGeoLookup();      // 早已授權，直接取得，不必打擾客人
      } else if (!cached) {
        this.coordStatus = state === 'denied' ? 'denied' : 'not_asked';
      }
    },

    startGeoLookup() {
      this.coordStatus = 'pending';
      const t0 = Date.now();
      this.coordPromise = new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.userCoords = {
              longitude: String(pos.coords.longitude),
              latitude: String(pos.coords.latitude),
            };
            this.coordStatus = 'granted';
            this.coordElapsed = Date.now() - t0;
            this.saveCachedCoords(this.userCoords);
            console.log('尋車座標來自瀏覽器定位:', this.userCoords, this.coordElapsed + 'ms');
            resolve();
          },
          (err) => {
            // 1=PERMISSION_DENIED  2=POSITION_UNAVAILABLE  3=TIMEOUT
            const code = err && err.code;
            this.coordStatus = code === 1 ? 'denied' : code === 3 ? 'timeout' : 'unavailable';
            this.coordElapsed = Date.now() - t0;
            console.log('取得定位失敗(' + this.coordStatus + ')', err && err.message);
            resolve();
          },
          { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
        );
      });
    },

    loadCachedCoords() {
      try {
        const raw = localStorage.getItem('twpk_last_coords');
        if (!raw) return null;
        const o = JSON.parse(raw);
        if (!o || !o.longitude || !o.latitude) return null;
        // 超過 7 天視為過期，避免用到早已離開的地點
        if (o.savedAt && Date.now() - o.savedAt > 7 * 24 * 3600 * 1000) return null;
        return { longitude: String(o.longitude), latitude: String(o.latitude) };
      } catch (e) {
        return null;
      }
    },

    saveCachedCoords(c) {
      try {
        localStorage.setItem('twpk_last_coords', JSON.stringify({
          longitude: c.longitude, latitude: c.latitude, savedAt: Date.now(),
        }));
      } catch (e) {
        // 無痕模式等情況下 localStorage 不可用，略過即可
      }
    },

    getDefaultParkingDict() {
      return {
        parking_id: "0000",
        title: '',
        address: 'NoWhere',
        agreement_id: 'ESTP9999',
        longitude: "121.525639",
        latitude: "25.057053"
      };
    },

    async onQueryParkingFee() {

        // 🔥 一按查詢就先滾到最上面
      window.scrollTo({ top: 0, behavior: 'smooth' });
  
      this.isLoading = true;

      // 定位是非同步的，客人可能在座標回來前就按查詢。
      // 此處最多等 3 秒，避免明明允許了定位卻送出不帶座標的請求。
      if (this.coordStatus === 'pending' && this.coordPromise) {
        this.loadingText = '取得您的位置中…';
        await Promise.race([
          this.coordPromise,
          new Promise((r) => setTimeout(r, 3000)),
        ]);
        if (this.coordStatus === 'pending') {
          this.coordStatus = 'waited_out';
          console.log('等待定位逾時，本次查詢不帶座標');
        }
      }

      const hasCoords = !!this.userCoords;
      this.loadingText = hasCoords ? '搜尋附近停車場…' : '車號查詢中…請稍後';

      //query car fee
      try {
        let restt;
        try {
          restt = await getEvents(
            this.carNumber,
            hasCoords ? this.userCoords.longitude : undefined,
            hasCoords ? this.userCoords.latitude : undefined,
            this.coordStatus
          );
        } catch (firstError) {
          // 帶座標時搜尋半徑僅 50 公里，客人若已離開停車場附近會查不到。
          // 自動改以全台範圍重查一次，避免比未帶座標時更查不到。
          if (!hasCoords) throw firstError;
          console.log('附近查無結果，擴大為全台範圍重查');
          this.loadingText = '擴大搜尋範圍，請稍候…';
          restt = await getEvents(this.carNumber, undefined, undefined, 'fallback_global');
        }

        // alert(JSON.stringify(restt));


        this.parking_id = restt.event.FieldNo;
        this.selectedParking.parking_id = this.parking_id;

        this.parkingFee = restt.fee;
        this.sessionId = restt.session_id;
        this.feeChangeRetried = false;   // 新的一筆交易，重設旗標
        this.remainingFee = restt.remainingFee;
        this.discount = restt.discount;
        this.currentStep = 'CarFee';
        this.parkingStartTime = restt.startTime.replace('T', ' ');
        this.selectedParking.startTime = this.parkingStartTime;

        this.selectedParking.agreement_id = getAgreementId(this.parking_id);

        this.event_id = restt.event.EventId;
        this.field_no = restt.event.FieldNo;
        this.plate_number = this.carNumber;

        this.selectedParking.title = restt.event.FieldInfo.DisplayName;
        console.log('parking title', this.selectedParking.title);
        console.log("DisplayName", restt.event.FieldInfo.DisplayName);

      } catch (error) {
        this.isLoading = false;
        this.loadingText = '車號查詢中…請稍後';

        alert('查無停車費用，請重新輸入車牌號碼；或是該車號正在繳費處理中，請稍後再試');
        this.currentStep = 'CarNumber';
      }

      this.isLoading = false;
      this.loadingText = '車號查詢中…請稍後';
      // this.parkingFee = await queryParkingFee(this.selectedParking.id, this.carNumber);
      // this.currentStep = 'CarFee';
    },




    async onQueryParkingFee_Old() {
      this.isLoading = true;
      //query car fee
      try {
        const restt = await queryParkingFee(this.selectedParking.parking_id, this.carNumber,
          this.selectedParking.longitude, this.selectedParking.latitude
        );
        this.parkingFee = restt.fee;
        this.sessionId = restt.session_id;
        this.feeChangeRetried = false;   // 新的一筆交易，重設旗標
        this.remainingFee = restt.remainingFee;
        this.discount = restt.discount;
        this.currentStep = 'CarFee';
        this.parkingStartTime = restt.startTime.replace('T', ' ');
        this.selectedParking.startTime = this.parkingStartTime;


      } catch (error) {
        this.isLoading = false;

        alert('查無停車費用，請重新輸入車牌號碼；或是該車號正在繳費處理中，請稍後再試');
        this.currentStep = 'CarNumber';
      }

      this.isLoading = false;
      // this.parkingFee = await queryParkingFee(this.selectedParking.id, this.carNumber);
      // this.currentStep = 'CarFee';
    },

    nextStep() {
      // Move to the next step
      // const currentIndex = this.steps.indexOf(this.currentStep);
      // this.currentStep = this.steps[currentIndex + 1];
    },

    updateState({ key, value }) {
      this[key] = value; // Update the state dynamically
      console.log('updateState', key, value);
    },

    // calculateDiscount() {
    //   const maxDiscount = 5; // Mock calculation logic
    //   this.selectedDiscountHours = Math.min(this.selectedDiscountHours, maxDiscount);
    //   this.unpaidFee = this.parkingFee - this.selectedDiscountHours * 10; // Example fee calculation
    //   return this.unpaidFee;
    // },

    onCancel() {
      this.carNumber = '';
      this.CardSelect = '';
      this.selectedOfferCard = '';
      this.sessionId = '';
      this.cardNumber = '';
      this.selectedDiscountHours = 0;
      this.remainingFee = 0;
      this.currentStep = 0;

      //reset selected parking to default
      this.selectedParking = this.getDefaultParkingDict();

      //got to CarNumber step
      this.currentStep = 'CarNumber';

      //goto OnlinePayment
      if (globalParams.prevRoute === undefined) {
        globalParams.prevRoute = '/OnlinePayment';
      }

      //reload page 
      // window.location.href = globalParams.prevRoute;
      // this.$router.go(0);
      // const prevRout = globalParams.prevRoute;
      // this.$router.push(prevRout);

    },

    goCardDiscount() {
      if (!this.supportsCardDiscount) {
        return;
      }

      if (this.$store.getters.user) {
        this.currentModal = 'CardSelectLogined';
      } else {
        // this.currentModal = 'CardSelect';
        this.enterCardNumber();
      }
    },

    async goOnlinePayment() {
      // https://webpay.fortune88.com.tw/PayFromCloud/SelectedAndPay?FieldNo=  J009(場號) &Car= AAA1234查詢的車號

      this.isLoading = true;
      
      // need to close transaction
      // 關帳失敗不阻擋繳費：部分場站的 TransactionClose 會回「設備連線逾時」，
      // 客人已經查到金額卻無法進入付款頁。與 ParkPay.vue 的處理方式一致，
      // 失敗只記錄 log，仍照常跳轉至金流頁。
      try {
        const close_status = await closeSession(this.selectedParking.parking_id, this.carNumber);
        console.log('close_status', close_status);
      } catch (error) {
        console.error('Error closing session:', error);
        console.log('But still proceed to payment');
      }

      this.isLoading = false;

      // Add your payment process logic here
      const paymentUrl = 'https://webpay.fortune88.com.tw/PayFromCloud/SelectedAndPay?FieldNo=' + this.selectedParking.parking_id + '&Car=' + this.carNumber;
      console.log('Proceeding to online payment for parking:', this.selectedParking);

      // console.log('Proceeding to payment for parking:', this.selectedParking);
      // console.log("pyament modal visible:", this.isPaymentModalVisible);
      //move the user to the payment page
      //window 115.05.13 跳轉視窗被擋
      //  .open(paymentUrl, '_blank')
      //  .focus();
      
      window.location.href = paymentUrl;
    },

    enterCardNumber() {
      this.currentModal = 'CardNumberEntry';
    },

    goBackToSelectCard() {
      if (this.$store.getters.user) {
        this.currentModal = 'CardSelectLogined';
      } else {
        // this.currentModal = 'CardSelect';
        this.currentModal = '';
      }
    },

    onCancelSelectCard() {
      this.currentModal = '';
    },

    async onQueryCardDiscount() {
      //query card discount
      // const parking_id = this.selectedParking.id;

      // const canDiscountHours = await queryCardDiscount(parking_id, this.carNumber, this.cardNumber);
      const canDiscountHours = 1;
      // alert('canDiscountHours', canDiscountHours);
      if (canDiscountHours > 0) {
        this.selectedDiscountHours = canDiscountHours;
        this.currentModal = 'SelectDiscountHours';


      } else if (canDiscountHours === 0) {
        alert('已經沒有可以折抵的時數');
        this.currentModal = 'CardNumberEntry';
      } else {
        alert('查詢折抵時數失敗，請重新輸入卡號');
        this.currentModal = 'CardNumberEntry';
      }
    },

    doubleConfirm() {
      this.currentModal = 'DoubleConfirm';
    },

    async attemptCardDiscount() {
      if (!this.supportsCardDiscount) {
        this.currentModal = '';
        return;
      }

      this.isLoading = true;



      //if discount > 0, then wait 2 seconds and alert this parking fee is already discounted , procees to online payment 
      if (this.discount > 0) {
        //wait 2 seconds
        await new Promise(resolve => setTimeout(resolve, 1000));
        alert('此停車費已折抵過，請直接繳費');
        this.onShowResidualFee();
        this.isLoading = false;
        this.currentModal = '';

        return;
      }

      // alert("attemptCardDiscount");
      // if (this.discount <=0 )
      // {
      //   this.currentModal = 'ShowSuccess';
      //   this.isLoading = false;
      //   return;
      // }

      try {

        const agreement_id = this.selectedParking.agreement_id;
        // const agreement_id = null;
        // console.log('attemptCardDiscountGlobal', this.event_id, this.field_no, this.plate_number, this.parkingFee, this.cardNumber, this.expireDate, agreement_id);
        console.log('attemptCardDiscount', this.session_id, this.parkingFee, this.cardNumber, this.expireDate, agreement_id);

        // const discountInfo = await doCardDiscountGlobal(this.event_id, this.field_no, this.plate_number, this.parkingFee, this.cardNumber, this.expireDate, this.parkingStartTime, agreement_id);
        const discountInfo = await doCardDiscount(this.sessionId, this.parkingFee, this.cardNumber, this.expireDate, this.parkingStartTime, agreement_id);

        console.log('discountInfo', discountInfo);
           

        // ── 逾時保護（後端可能回 reason）──────────────────────
        if (discountInfo.reason === 'fee_changed') {
          // 停留超過門檻，後端重開 session 後發現跨了計費區間。
          // 一定要讓客人自己決定，不能拿新金額直接去刷卡。
          const ok = confirm(
            `停車費已更新為 ${discountInfo.new_fee} 元（原 ${discountInfo.old_fee} 元），是否繼續折抵？`
          );
          if (!ok) {
            this.isLoading = false;
            this.goBackToSelectCard();
            return;
          }
          if (this.feeChangeRetried) {
            alert('停車費持續變動，請重新查詢車號');
            this.isLoading = false;
            this.onCancel();
            return;
          }
          this.feeChangeRetried = true;
          this.sessionId = discountInfo.session_id;
          this.parkingFee = discountInfo.new_fee;
          this.isLoading = false;
          return this.attemptCardDiscount();
        }

        if (discountInfo.reason === 'apply_failed') {
          // 卡片已經授權成功，只是折抵沒套上。不要把客人送回選卡畫面，
          // 否則他順手再刷一次就會被扣兩次紅利。
          alert(discountInfo.message);
          this.isLoading = false;
          this.currentModal = '';
          return;
        }

        if (discountInfo.reason) {
          alert(discountInfo.message || '折抵失敗，請重新查詢車號');
          this.isLoading = false;
          this.onCancel();
          return;
        }

        const residualFee = discountInfo.residual_fee;
        const discount = discountInfo.discounted_fee;

        console.log('residualFee', residualFee);

        if (residualFee >= 0) {
          this.remainingFee = residualFee;
          this.discount = discount;
          this.currentModal = 'ShowSuccess';
        } else {
          alert('無可折抵紅利');
          this.goBackToSelectCard();
        }
      } catch (error) {
        // alert('無可折抵紅利');
        alert(error || '無可折抵紅利');
        this.goBackToSelectCard();
      }

      this.isLoading = false;
    },



    // goCalculateDiscount() {

    //   this.parkingFee = this.calculateDiscount();
    //   alert('calculate discount', this.parkingFee);

    //   this.currentStep = 'CarFee';
    // },

    async onShowResidualFee() {
      try {
        // const restt = await queryParkingFee(this.selectedParking.parking_id, this.carNumber,
        //   this.selectedParking.longitude, this.selectedParking.latitude
        // );
        // this.parkingFee = restt.fee;

        this.currentStep = 'RemainFee';
        // this.resetData();

      } catch (error) {
        alert('查無停車費用，請重新輸入車牌號碼');
        this.currentStep = 'CarNumber';
        this.resetData();

      }
      //clear all other variables
      // this.carNumber = '';


    },

    resetData() {

      this.CardSelect = '';
      this.selectedOfferCard = '';
      this.cardNumber = '';
      this.selectedDiscountHours = 0;
      this.unpaidFee = 0;
      // this.currentStep = 0;
    }




  },
  mounted() {
    // wait for the page to load
    // this.parkingTitle = this.selectedParking.title;
    // alert(this.parkingTitle);

    this.initUserCoords();
  },
  components: {
    LoadingSpinner,
    CarNumber,
    CarFee,
    CardSelect,
    CardSelectLogined,
    CardNumberEntry,
    CalculateDiscount,
    SelectDiscountHours,
    MyConfirm,
    DoubleConfirm,
    ShowSuccess,
    DisplayResidualFee,
    RemainFee
  }
};
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  background-color: #f5f5f5;
}

.payboard {
  display: flex;
  /* flex-direction: column; */
  gap: 30px;
  justify-content: center;
  align-items: center;
  min-height: 10vh;
  background-color: #b6fff6;
}
</style>
